/** True when a fetch was cancelled via AbortController (e.g. page unmount).

  Chromium often reports an aborted request as TypeError "Failed to fetch"
  instead of AbortError — treat an aborted signal as cancel, not a real error.
*/
export function isAbortError(err, signal) {
  if (signal?.aborted) return true;
  const name = err?.name || "";
  const msg = String(err?.message || "");
  return (
    name === "AbortError" ||
    name === "CanceledError" ||
    msg === "The user aborted a request." ||
    /aborted without reason/i.test(msg)
  );
}
